import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useApp } from '../data/ColisContext';

export default function RequireAuth({ children }) {
  const { user } = useApp();
  const location = useLocation();

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
}
